<template>
    <Dialog v-model:visible="visible" pt:root:class="!border-0 !bg-transparent" pt:mask:class="backdrop-blur-sm"
        :closeOnEscape="false" id="login-dialog">
        <form v-if="isLogin" @submit.prevent="submitForm" class="flex flex-col px-6 py-6 gap-4 rounded-2xl" style="background-image: radial-gradient(circle at left top, var(--p-rose-400),
                var(--p-rose-600))">
            <svg width="35" height="40" viewBox="0 0 35 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="block mx-auto">
                <path
                    d="M25.87 18.05L23.16 17.45L25.27 20.46V29.78L32.49 23.76V13.53L29.18 14.73L25.87 18.04V18.05ZM25.27 35.49L29.18 31.58V27.67L25.27 30.98V35.49ZM20.16 17.14H20.03H20.17H20.16ZM30.1 5.19L34.89 4.81L33.08 12.33L24.1 15.67L30.08 5.2L30.1 5.19ZM5.72 14.74L2.41 13.54V23.77L9.63 29.79V20.47L11.74 17.46L9.03 18.06L5.72 14.75V14.74ZM9.63 30.98L5.72 27.67V31.58L9.63 35.49V30.98ZM4.8 5.2L10.78 15.67L1.81 12.33L0 4.81L4.79 5.19L4.8 5.2ZM24.37 21.05V34.59L22.56 37.29L20.46 39.4H14.44L12.34 37.29L10.53 34.59V21.05L12.42 18.23L17.45 26.8L22.48 18.23L24.37 21.05ZM22.85 0L22.57 0.69L17.45 13.08L12.33 0.69L12.05 0H22.85Z"
                    fill="var(--p-neutral-700)" />
                <path
                    d="M30.69 4.21L24.37 4.81L22.57 0.69L22.86 0H26.48L30.69 4.21ZM23.75 5.67L22.66 3.08L18.05 14.24V17.14H19.7H20.03H20.16H20.2L24.1 15.7L30.11 5.19L23.75 5.67ZM4.21002 4.21L10.53 4.81L12.33 0.69L12.05 0H8.43002L4.22002 4.21H4.21002ZM21.9 17.4L20.6 18.2H14.3L13 17.4L12.4 18.2L12.42 18.23L17.45 26.8L22.48 18.23L22.5 18.2L21.9 17.4ZM4.79002 5.19L10.8 15.7L14.7 17.14H14.74H15.2H16.85V14.24L12.24 3.09L11.15 5.68L4.79002 5.2V5.19Z"
                    fill="var(--p-neutral-200)" />
            </svg>

            <div class="inline-flex flex-col gap-2">
                <label for="username" class="text-neutral-50 font-semibold">{{
                    $t('login_register_form.user_name_and_mail') }}</label>
                <InputText id="username" class="!bg-white/20 !border-0 !p-4 !text-neutral-50 w-80"
                    autocomplete="username" v-model="loginFormData.username"></InputText>
            </div>
            <div class="inline-flex flex-col gap-2">
                <label for="password" class="text-neutral-50 font-semibold">{{ $t('login_register_form.password')
                    }}</label>
                <InputText id="password" class="!bg-white/20 !border-0 !p-4 !text-neutral-50 w-80" type="password"
                    autocomplete="current-password" v-model="loginFormData.password" @keyup.enter="submitForm">
                </InputText>
            </div>

            <div v-if="loginSecurity.key" class="g-recaptcha" :data-sitekey="loginSecurity.key" id="recaptchaLogin">
            </div>


            <div class="inline-flex flex-col gap-2" v-if="login_error">
                {{ $t('login_register_form.invalid_password') }}
            </div>
            <div class="flex items-center gap-2 column">
                <Button :label="$t('login_register_form.login')" severity="contrast" @click="submitForm"
                    class="!p-4 w-full"></Button>
                <Button :label="$t('login_register_form.register')" severity="secondary" @click="isLogin = false"
                    class="!p-4 w-full"></Button>
                <Button :label="$t('login_register_form.guest_login')" severity="help" @click="guestLogin"
                    class="!p-4 w-full"></Button>

            </div>

        </form>
        <form v-else @submit.prevent="submitFormRegister" class="flex flex-col px-6 py-6 gap-4 rounded-2xl" style="background-image: radial-gradient(circle at left top, var(--p-rose-400),
                var(--p-rose-600))">
            <svg width="35" height="40" viewBox="0 0 35 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="block mx-auto">
                <path
                    d="M25.87 18.05L23.16 17.45L25.27 20.46V29.78L32.49 23.76V13.53L29.18 14.73L25.87 18.04V18.05ZM25.27 35.49L29.18 31.58V27.67L25.27 30.98V35.49ZM20.16 17.14H20.03H20.17H20.16ZM30.1 5.19L34.89 4.81L33.08 12.33L24.1 15.67L30.08 5.2L30.1 5.19ZM5.72 14.74L2.41 13.54V23.77L9.63 29.79V20.47L11.74 17.46L9.03 18.06L5.72 14.75V14.74ZM9.63 30.98L5.72 27.67V31.58L9.63 35.49V30.98ZM4.8 5.2L10.78 15.67L1.81 12.33L0 4.81L4.79 5.19L4.8 5.2ZM24.37 21.05V34.59L22.56 37.29L20.46 39.4H14.44L12.34 37.29L10.53 34.59V21.05L12.42 18.23L17.45 26.8L22.48 18.23L24.37 21.05ZM22.85 0L22.57 0.69L17.45 13.08L12.33 0.69L12.05 0H22.85Z"
                    fill="var(--p-neutral-700)" />
                <path
                    d="M30.69 4.21L24.37 4.81L22.57 0.69L22.86 0H26.48L30.69 4.21ZM23.75 5.67L22.66 3.08L18.05 14.24V17.14H19.7H20.03H20.16H20.2L24.1 15.7L30.11 5.19L23.75 5.67ZM4.21002 4.21L10.53 4.81L12.33 0.69L12.05 0H8.43002L4.22002 4.21H4.21002ZM21.9 17.4L20.6 18.2H14.3L13 17.4L12.4 18.2L12.42 18.23L17.45 26.8L22.48 18.23L22.5 18.2L21.9 17.4ZM4.79002 5.19L10.8 15.7L14.7 17.14H14.74H15.2H16.85V14.24L12.24 3.09L11.15 5.68L4.79002 5.2V5.19Z"
                    fill="var(--p-neutral-200)" />
            </svg>

            <div class="inline-flex flex-col gap-2">
                <label for="username2" class="text-neutral-50 font-semibold">{{ $t('login_register_form.username')
                    }}</label>
                <InputText id="username2" class="!bg-white/20 !border-0 !p-4 !text-neutral-50 w-80"
                    autocomplete="username" v-model="registerFormData.username" required></InputText>
            </div>
            <div class="inline-flex flex-col gap-2">
                <label for="mail2" class="text-neutral-50 font-semibold">{{ $t('login_register_form.email') }}</label>
                <InputText id="mail2" class="!bg-white/20 !border-0 !p-4 !text-neutral-50 w-80" type="email" required
                    autocomplete="current-email" v-model="registerFormData.email" :disabled="isCheckedNoMail">
                </InputText>
            </div>

            <div class="inline-flex flex-centered gap-2">
                <Checkbox v-model="isCheckedNoMail" :binary="true" @click="confirm1" />
                <label class="ml-2">{{ $t('login_register_form.no_mail') }}</label>

            </div>


            <div class="inline-flex flex-col gap-2">
                <label for="password2" class="text-neutral-50 font-semibold">{{ $t('login_register_form.password')
                    }}</label>
                <InputText id="password2" class="!bg-white/20 !border-0 !p-4 !text-neutral-50 w-80" type="password"
                    required autocomplete="current-password" v-model="registerFormData.password">
                </InputText>
            </div>

            <div class="inline-flex flex-col gap-2">
                <label for="gender" class="text-neutral-50 font-semibold">{{ $t('login_register_form.gender') }}</label>

                <Select v-model="registerFormData.gender" :options="genders" optionLabel="name" optionValue="id"
                    required class="!bg-white/20 !border-0 !p-4 !text-neutral-50 w-80" />


            </div>
            <div v-if="registerSecurity.key" class="g-recaptcha" :data-sitekey="registerSecurity.key"
                id="recaptchaRegister"></div>


            <div class="inline-flex flex-col gap-2" v-if="register_err">
                {{ register_err }}
            </div>

            <div class="flex items-center gap-2 column">
                <Button :label="$t('login_register_form.register')" severity="contrast" type="submit"
                    class="!p-4 w-full"></Button>
                <Button :label="$t('login_register_form.login')" severity="secondary" @click="isLogin = true"
                    class="!p-4 w-full"></Button>
                <Button :label="$t('login_register_form.guest_login')" severity="help" v-if="isLogin" @click="guestLogin"
                    class="!p-4 w-full"></Button>
            </div>
        </form>
    </Dialog>
</template>

<script>
import axios from 'axios';

export default {
    props: ['login_complated'],
    data() {
        return {
            visible: false,
            isLogin: true,
            login_error: false,
            isRecaptchaLoaded: false,
            register_err: false,
            isCheckedNoMail: null,
            loginSecurity: {
                key: null,
                token: null,
                id: null,
                client_id: null
            },
            registerSecurity: {
                key: null,
                token: null,
                id: null,
                client_id: null
            },

            registerFormData: {
                username: '',
                email: '',
                password: '',
                gender: 0,
            },
            loginFormData: {
                username: '',
                password: ''
            }
        };
    },
    watch: {
        login_complated(newValue) {
            if (newValue !== true)
                this.visible = true;
            else {
                this.visible = false;
            }
        },
        isCheckedNoMail(newValue) {
            if (newValue) {
                this.registerFormData.email = 'no-mail';
            } else {
                this.registerFormData.email = '';
            }
        },
    },
    computed: {
        genders() {
            return this.$tm('genders');
        }
    },

    async mounted() {
        await this.loadRecaptcha();
    },
    methods: {

        onVerifyLogin(token) {
            console.log(token);
            this.loginSecurity.token = token
        },
        confirm1(event) {
            event.preventDefault();
            if (this.isCheckedNoMail == true) {
                this.registerFormData.email = '';
                this.isCheckedNoMail = null
                return;
            }

            this.$confirm.require({
                message: 'Are you sure you want to proceed?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                rejectProps: {
                    label: 'Cancel',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Yes'
                },
                accept: () => {
                    this.isCheckedNoMail = true
                },
                reject: () => {
                    this.isCheckedNoMail = null
                }
            });
        },
        loadRecaptcha() {
            return new Promise((resolve) => {
                if (document.getElementById("recaptcha-script")) {
                    if (window.grecaptcha) {
                        this.isRecaptchaLoaded = true;
                        resolve(true);
                    } else {
                        document.getElementById("recaptcha-script").onload = () => {
                            this.isRecaptchaLoaded = true;
                            resolve(true);
                        };
                    }
                    return;
                }

                const script = document.createElement("script");
                script.src = "https://www.google.com/recaptcha/api.js";
                script.async = true;
                script.defer = true;
                script.id = "recaptcha-script";

                script.onload = () => {
                    this.isRecaptchaLoaded = true;
                    resolve(true);
                };

                document.head.appendChild(script);
            });
        },

        closeCallback() {
            this.visible = true;
        },
        registerForm() {
            this.visible = true;
        },
        async submitForm() {

            let recaptchaToken = null;
            if (document.getElementById('recaptchaLogin')) {
                recaptchaToken = window.grecaptcha.getResponse(this.loginSecurity.client_id);
                if (!recaptchaToken) {
                    alert("Please verify that you are not a robot.");
                    return;
                }
            }


            try {
                const response = await axios.post(this.$socket_url + '/login', {
                    username: this.loginFormData.username,
                    password: this.loginFormData.password,
                    recaptchaToken: recaptchaToken,
                    c_id: this.loginSecurity.id
                });
                if (response.data.status === true) {
                    this.$emit('login-completed', { user_id: response.data.user_id, password: this.loginFormData.password },);
                } else {

                    if (response.data.reCAPTCHA_public) {
                        this.loginSecurity.key = response.data.reCAPTCHA_public;
                        this.loginSecurity.id = response.data.reCAPTCHA_public_id;
                        setTimeout(() => {

                            if (document.getElementById('recaptchaLogin') && !this.loginSecurity.client_id) {
                                try {
                                    this.loginSecurity.client_id = window.grecaptcha.render('recaptchaLogin');
                                } catch (error) {
                                    console.log(error);
                                }
                            }


                        }, 500);
                        return;
                    }
                    this.login_error = true;
                }


            } catch (error) {
                console.log(error);
            }
        },
        async submitFormRegister() {
            try {

                let recaptchaToken = null;
                if (document.getElementById('recaptchaRegister')) {
                    recaptchaToken = window.grecaptcha.getResponse(this.registerSecurity.client_id);
                    if (!recaptchaToken) {
                        alert("Please verify that you are not a robot.");
                        return;
                    }
                }



                const response = await axios.post(this.$socket_url + '/register', {
                    username: this.registerFormData.username,
                    email: this.registerFormData.email,
                    password: this.registerFormData.password,
                    gender: this.registerFormData.gender,
                    recaptchaToken
                });

                if (this.registerSecurity.client_id) {
                    window.grecaptcha.reset(this.registerSecurity.client_id);
                }

                if (response.data.status === true) {
                    this.$emit('login-completed', { user_id: response.data.user_id, password: this.registerFormData.password });
                } else {



                    if (response.data.reCAPTCHA_public) {
                        this.registerSecurity.key = response.data.reCAPTCHA_public;
                        this.registerSecurity.id = response.data.reCAPTCHA_public_id;
                        setTimeout(() => {

                            if (document.getElementById('recaptchaLogin') && !this.loginSecurity.client_id) {
                                try {
                                    this.registerSecurity.client_id = window.grecaptcha.render('recaptchaRegister');
                                } catch (error) {
                                    console.log(error);
                                }
                            }


                        }, 500);
                        return;
                    }
                    this.login_error = true;



                    if (response.data.error == 1) {
                        this.register_err = this.$t('login_register_form.username_exists');
                    } else {
                        this.register_err = this.$t('login_register_form.there_is_an_error');
                    }
                }
            } catch (error) {
                this.register_err = this.$t('login_register_form.there_is_an_error');
            }
        },
        async guestLogin() {
            if (localStorage.getItem('guest_user_id') && localStorage.getItem('guest_user_password')) {
                try {

                    let recaptchaToken = null;
                    if (document.getElementById('recaptchaLogin')) {
                        recaptchaToken = window.grecaptcha.getResponse(this.loginSecurity.client_id);
                        if (!recaptchaToken) {
                            alert("Please verify that you are not a robot.");
                            return;
                        }
                    }

                    const response = await axios.post(this.$socket_url + '/login', {
                        user_id: localStorage.getItem('guest_user_id'),
                        password: localStorage.getItem('guest_user_password'),
                        recaptchaToken
                    });
                    if (response.data.status === true) {
                        this.$emit('login-completed', { user_id: localStorage.getItem('guest_user_id'), password: localStorage.getItem('guest_user_password'), isGuest: true });
                    } else {


                        if (response.data.reCAPTCHA_public) {
                            this.loginSecurity.key = response.data.reCAPTCHA_public;
                            this.loginSecurity.id = response.data.reCAPTCHA_public_id;
                            setTimeout(() => {

                                if (document.getElementById('recaptchaLogin') && !this.loginSecurity.client_id) {
                                    try {
                                        this.loginSecurity.client_id = window.grecaptcha.render('recaptchaLogin');
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }


                            }, 500);
                            return;
                        }


                        localStorage.removeItem('guest_user_id');
                        localStorage.removeItem('guest_user_password');
                        this.createGuestLogin();
                        return;
                    }
                } catch (error) {
                    return;
                }
            } else {
                this.createGuestLogin();
            }
        },
        async createGuestLogin() {
            try {


                let recaptchaToken = null;
                if (document.getElementById('recaptchaLogin')) {
                    recaptchaToken = window.grecaptcha.getResponse(this.loginSecurity.client_id);
                    if (!recaptchaToken) {
                        alert("Please verify that you are not a robot.");
                        return;
                    }
                }

                const response = await axios.post(this.$socket_url + '/guest', {
                    recaptchaToken
                });
                if (response.data.status === true) {
                    localStorage.setItem('guest_user_id', response.data.user_id);
                    localStorage.setItem('guest_user_password', response.data.password);
                    this.$emit('login-completed', { user_id: response.data.user_id, password: response.data.password, isGuest: true });
                } else {

                    if (response.data.reCAPTCHA_public) {
                        this.loginSecurity.key = response.data.reCAPTCHA_public;
                        this.loginSecurity.id = response.data.reCAPTCHA_public_id;
                        setTimeout(() => {

                            if (document.getElementById('recaptchaLogin') && !this.loginSecurity.client_id) {
                                try {
                                    this.loginSecurity.client_id = window.grecaptcha.render('recaptchaLogin');
                                } catch (error) {
                                    console.log(error);
                                }
                            }


                        }, 500);
                        return;
                    }



                    this.register_err = this.$t('login_register_form.there_is_an_error');
                    return;
                }
            } catch (error) {
                this.register_err = this.$t('login_register_form.there_is_an_error');
                return;
            }
        }

    }
};
</script>
<style scoped>
.flex.column {
    flex-direction: column;
}

.p-button-help {
    background: #5c189c;
}

.flex-centered {
    display: flex;
    align-items: center;
}
</style>
